import { action, extendObservable } from 'mobx';

class DraftItemExtraColumnService {
  constructor() {
    extendObservable(this, {
      columns: [],
    });
  }

  init = action(() => {
    const selectedExtraColumns = localStorage.getItem('selectedExtraColumns');
    this.columns = selectedExtraColumns
      ? JSON.parse(selectedExtraColumns)
      : ['audio', 'audioAssetsStatus', 'image', 'imageAssetsStatus', 'draftCreationReason'];
  });

  handleChange = action((columns) => {
    this.columns = columns;
    localStorage.setItem('selectedExtraColumns', JSON.stringify(columns));
  });
}

const draftItemExtraColumnService = new DraftItemExtraColumnService();

export default draftItemExtraColumnService;
